import { render } from "./SectionEmployeeProfile.vue?vue&type=template&id=4ee26534&scoped=true"
import script from "./SectionEmployeeProfile.vue?vue&type=script&lang=js"
export * from "./SectionEmployeeProfile.vue?vue&type=script&lang=js"

import "./SectionEmployeeProfile.vue?vue&type=style&index=0&id=4ee26534&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ee26534"]])

export default __exports__